import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=b2d663be&scoped=true"
import script from "./PackageList.vue?vue&type=script&lang=js"
export * from "./PackageList.vue?vue&type=script&lang=js"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=b2d663be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d663be",
  null
  
)

export default component.exports